export default __webpack_public_path__ + "static/media/score.69dc508c.svg";